import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import {
  StateService,
  RouterService,
  ToolService,
  ConstructionDayReport,
  ConstructionDayReportType,
  ConstructionSite,
  ModalService,
} from 'projects/shared/src/public-api';
import { ModalController, Platform } from '@ionic/angular';

@Component({
  selector: 'lib-construction-day-report-overview',
  templateUrl: './construction-day-report-overview.component.html',
  styleUrls: ['./construction-day-report-overview.component.scss'],
  standalone: false,
})
export class ConstructionDayReportOverviewComponent implements OnInit {
  constructor(
    public state: StateService,
    public routerService: RouterService,
    public toolService: ToolService,
    public modalCtrl: ModalController,
    public platform: Platform,
    public modalService: ModalService
  ) {}

  private subs: Subscription[] = [];
  private conDayReportsDB: ConstructionDayReport[] = [];
  conDayReports: ConstructionDayReport[] = [];
  selectedConSite: string;
  selectedMonth: number = new Date().getMonth();
  selectedYear: number = new Date().getFullYear();
  ConstructionDayReportType = ConstructionDayReportType;
  private searchTerm: string;
  private constructionSites: ConstructionSite[] = [];

  ngOnInit() {
    this.subs.push(
      this.state.constructionDayReports$.subscribe((x) => {
        this.conDayReportsDB = x;
        this.filterConstructionDayReports();
      })
    );
    this.subs.push(
      this.state.conSites$.subscribe((x) => (this.constructionSites = x))
    );
  }

  filterConstructionDayReports() {
    this.conDayReports = this.conDayReportsDB;
    if (this.selectedConSite != null) {
      this.conDayReports = this.conDayReports?.filter(
        (x) => x.constructionSite == this.selectedConSite
      );
    }
    if (this.selectedMonth != null) {
      this.conDayReports = this.conDayReports?.filter(
        (x) => new Date(x.date).getMonth() == this.selectedMonth
      );
    }
    if (this.selectedYear != null) {
      this.conDayReports = this.conDayReports?.filter(
        (x) => new Date(x.date).getFullYear() == this.selectedYear
      );
    }

    if (this.searchTerm) {
      const conSites = this.constructionSites
        .filter(
          (x) =>
            x.address.toLocaleLowerCase().includes(this.searchTerm) ||
            x.city.toLocaleLowerCase().includes(this.searchTerm) ||
            x.name.toLocaleLowerCase().includes(this.searchTerm) ||
            x.contactName1?.toLocaleLowerCase().includes(this.searchTerm)
        )
        .map((x) => x.id);
      this.conDayReports = this.conDayReports?.filter(
        (x) =>
          x.rapport?.toLocaleLowerCase().includes(this.searchTerm) ||
          x.report?.toLocaleLowerCase().includes(this.searchTerm) ||
          x.specialIncidents?.toLocaleLowerCase().includes(this.searchTerm) ||
          x.difficulties?.toLocaleLowerCase().includes(this.searchTerm) ||
          x.workers?.find((y) =>
            y.toLocaleLowerCase().includes(this.searchTerm)
          ) != null ||
          conSites.includes(x.constructionSite)
      );
    }
  }

  ngOnDestroy() {
    this.subs.forEach((x) => x.unsubscribe());
  }

  public conSiteChange(conSiteId: string) {
    this.selectedConSite = conSiteId;
    this.filterConstructionDayReports();
  }

  public yearChange(year: number) {
    this.selectedYear = year;
    // check here if year data is already loaded from backend
    this.filterConstructionDayReports();
  }

  public monthChange(month: number) {
    this.selectedMonth = month;
    this.filterConstructionDayReports();
  }

  public async openConstructionDayReportDetailModal(id: string) {
    await this.modalService.openConstructionDayReportDetailModal(
      id,
      this.state.isBigScreen
    );
  }

  public async openConstructionDayReportFormModal(id: string) {
    await this.modalService.openConstructionDayReportFormModal(
      id,
      this.state.isBigScreen
    );
  }

  public setSearchTerm(event: any): void {
    this.searchTerm = (event.detail.value as string).toLocaleLowerCase().trim();
    this.filterConstructionDayReports();
  }
}
